import { useEffect, useState } from "react";
import AddPlanView from "./AddPlanView";

import { PlusThinWhiteIcon, DeleteRedIcon, EditIcon } from "../../../assets/icons";
import { planService } from "../../../services/planService";
import { useInRouterContext } from "react-router-dom";
import { useNotification } from "../../toster-notification/NotificationContext";
import { Switch } from "@mui/material";
import { confirmDialog } from "../../../utils/confirmDialog";
import EditPlanView from "./EditPlanView";
import { PlanListItemDTO } from "../../../models/plan/plan.response";


const PlansPage: React.FC = () => {

    const [isAddPlanModalOpen, setIsAddPlanModalOpen] = useState(false);
    const [isEditPlanModalOpen, setIsEditPlanModalOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState<PlanListItemDTO | null>(null);

    const [plans, setPlans] = useState<PlanListItemDTO[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = async () => {
        setLoading(true);

        try {
            const response = await planService.getPlans();

            if (response.success && response.data) {
                setPlans(response.data);
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "Filed fetch plans");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSoftDeletePlan = async (planId: string) => {
        setLoading(true);

        try {
            const response = await planService.softDelete(planId);

            if (response.success) {
                notify("success", response.message || "Plan successfully deactivated.");
                fetchPlans();
            } else {
                notify("error", response.message || "Failed to delete plan");
            }

        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "Failed to delete plan");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleHardDelete = async (planId: string) => {
        setLoading(true);

        const confirm = await confirmDialog({
            title: "Confirm Deletion",
            description: "Are you sure you want to permanently delete this plan? This action cannot be undone.",
            isDelete: true
        });

        if (!confirm) {
            return;
        }

        try {
            const response = await planService.hardDelete(planId);
            if (response.success) {
                notify("success", response.message || "Plan successfully deleted.");
                fetchPlans();
            } else {
                notify("error", response.message || "Failed to delete plan");
            }

        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "Failed to delete plan");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleRestorePlan = async (planId: string) => {
        setLoading(true);
        try {
            const response = await planService.restore(planId);

            if (response.success) {
                notify("success", response.message || "Plan successfully restored.");
                fetchPlans();
            }

        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "Failed to restore plan");
            }
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {isAddPlanModalOpen && (
                <AddPlanView
                    onClose={() => {
                        setIsAddPlanModalOpen(false)
                        fetchPlans();
                    }} />
            )}

            {isEditPlanModalOpen && selectedPlan && (
                <EditPlanView
                    planId={selectedPlan.id}
                    onClose={() => {
                        setIsEditPlanModalOpen(false);
                        setSelectedPlan(null);
                        fetchPlans();
                    }} />
            )}

            <section className="sa-plans-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Planovi Pretplate</h2>
                                <div className="text-block">
                                    Upravljanje paketima članarine<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary " onClick={() => setIsAddPlanModalOpen(true)}>
                                    <img loading="lazy" src={PlusThinWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Novi plan</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Dostupni Planovi</div>
                                    <div className="list-header-description">
                                        Ukupno {plans.length} planova ({plans.filter(plan => plan.isDeleted === false).length} aktivnih)<br />
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row plans">
                                    <div>
                                        <strong>Plan</strong>
                                    </div>
                                    <div>
                                        <strong>Cena</strong>
                                    </div>
                                    <div>
                                        <strong>Trajanje</strong>
                                    </div>
                                    <div>
                                        <strong>Lokacije</strong>
                                    </div>
                                    <div>
                                        <strong>Funkcije</strong>
                                    </div>
                                    <div>
                                        <strong>Status</strong>
                                    </div>
                                    <div id="w-node-_78107f73-878e-7d60-5708-ae790111c486-1cee91cf">Akcije</div>
                                </div>

                                {plans.map((plan, index) => (
                                    <div className="list-row-div plans" key={index}>
                                        <div>
                                            <div className="bold-1rem">{plan.name}</div>
                                            <div className="description-text">{plan.description.slice(0, 50) + (plan.description.length > 50 ? "..." : "")}</div>
                                        </div>
                                        <div>{plan.price} RSD</div>
                                        <div>{plan.durationDays} dana</div>
                                        <div>not implement</div>
                                        <div className="div-block-29">

                                            {plan.planFeatureNames
                                                .slice(0, 2)
                                                .map((planFeature) => (
                                                    <div className="small-box-div">
                                                        <div>{planFeature.slice(0, 20) + (planFeature.length > 10 ? "..." : "")}</div>
                                                    </div>
                                                ))}
                                            {plan.planFeatureNames.length > 2 &&
                                                (
                                                    <div className="small-box-div">
                                                        <div>{`+${plan.planFeatureNames.length - 2}`}</div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <Switch
                                            checked={!plan.isDeleted}
                                            onChange={() => {
                                                if (plan.isDeleted) {
                                                    handleRestorePlan(plan.id);
                                                } else {
                                                    handleSoftDeletePlan(plan.id);
                                                }
                                            }}
                                        />
                                        <div id="w-node-_3477d8c3-cd02-3b4f-a1c1-f77c01437cfe-1cee91cf" className="table-row-action-btns-div">
                                            <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                                                onClick={() => {
                                                    setSelectedPlan(plan);
                                                    setIsEditPlanModalOpen(true);
                                                }} />
                                            <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image" onClick={() => handleHardDelete(plan.id)} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );

};

export default PlansPage;